module.exports = __webpack_public_path__ + "static/media/18ECA4.0056aae6.jpg";